import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../../redux/store";
import { closePaymentConfirmationDialog } from "../../../../redux/slices/projectsSlice";
import { chargeInvoice } from "../../../../redux/slices/invoicesSlice";
import { useCallback, useEffect, useMemo } from "react";

const PaymentConfirmationDialog = () => {
  const { changes: invoiceChanges, selectedInvoice } = useAppSelector(
    (state) => state.invoices
  ) as any;

  const { selectedProject, paymentConfirmationDialogOpen } = useAppSelector(
    (state) => state.projects
  ) as any;

  const { invoiceChargeStatus } = useAppSelector((state) => state.invoices) as any;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (invoiceChargeStatus === "succeeded" && paymentConfirmationDialogOpen) {
      dispatch(closePaymentConfirmationDialog());
    }
  }, [invoiceChargeStatus, paymentConfirmationDialogOpen, dispatch]);

  const handleClose = useCallback(() => {
    dispatch(closePaymentConfirmationDialog());
  }, [dispatch]);

  const amountToCharge = useMemo(() => {
    return (
      invoiceChanges?.amount ||
      selectedInvoice?.amountDue - selectedInvoice?.scheduledAmount ||
      selectedInvoice?.amount
    );
  }, [
    invoiceChanges?.amount,
    selectedInvoice?.amountDue,
    selectedInvoice?.scheduledAmount,
    selectedInvoice?.amount,
  ]);

  const handleChargeInvoice = (event: any) => {
    event.preventDefault();

    dispatch(
      chargeInvoice({
        customerId: selectedInvoice?.customerId,
        invoiceId: selectedInvoice?.id,
        accountId: invoiceChanges?.accountId,
        amount: amountToCharge?.toString(),
      })
    );
  };

  return (
    <Dialog
      open={paymentConfirmationDialogOpen}
      maxWidth="xs"
      component={"form"}
      onSubmit={handleChargeInvoice}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 0,
          padding: 2,
        },
        "& .MuiOutlinedInput-input": {
          p: "4.5px 14px",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: 0,
        },
        "& .MuiTextField-root": {
          mt: 0,
        },
        "& .MuiButton-root": {
          borderRadius: 0,
          p: "2.75px 15px",
        },
      }}
    >
      <DialogTitle
        sx={{
          "&.MuiDialogTitle-root": { p: 0 },
        }}
      >
        Payment Confirmation | Invoice # {selectedInvoice?.invoiceNumber}
      </DialogTitle>
      <DialogContent>
        <Typography
          style={{
            fontFamily: "Brandon_Grotesque_bold",
          }}
        >
          {selectedProject?.name}
        </Typography>
        <Grid
          sx={{
            mt: 1,
          }}
          container
        >
          <Grid size={12}>
            <Typography variant="body2">Amount to Pay:</Typography>
          </Grid>
          <Grid size={12}>
            <Typography
              sx={{ fontFamily: "Brandon_Grotesque_medium" }}
              variant="body2"
            >
              {parseFloat(amountToCharge)?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          type="submit"
          variant="contained"
          color="success"
          disabled={invoiceChargeStatus === "loading"}
        >
          Confirm & Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentConfirmationDialog;
